import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";

import { useState } from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RevokeProposalModal from "../modals/RevokeProposalModal";
import { CancelLockupProposal } from "../../../../apis/__generated__/graphql";

export interface RevokeProposalButtonProps {
  refetch: () => void;
  row?: CancelLockupProposal;
  disabled: boolean;
  onSelectedRow: () => void;
  onUnselectedRow: () => void;
}

export default function RevokeProposalButton({
  refetch,
  row,
  disabled,
  onSelectedRow,
  onUnselectedRow,
}: RevokeProposalButtonProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    onSelectedRow();
  };

  const handleClose = () => {
    setOpen(false);
    onUnselectedRow();
  };

  return (
    <>
      <GridActionsCellItem
        label="Remove"
        icon={
          <Tooltip title="Remove">
            <DeleteForeverIcon />
          </Tooltip>
        }
        onClick={handleOpen}
        disabled={disabled}
      />
      {row && (
        <RevokeProposalModal
          row={row}
          open={open}
          onClose={handleClose}
          refetch={refetch}
        />
      )}
    </>
  );
}
